import { Icon } from "@findemdev/maui";
import { PAGINATION_ELLIPSIS } from "../../constants";
import {
  PageButton,
  Pagination,
  PaginationEllipsis,
} from "../../RaasClientPortal.styled";

interface IProjectsPaginationProps {
  canGoNext?: boolean;
  onNextPage: () => void;
  onPageClick: ({ pageNumber }: { pageNumber: number }) => void;
  onPreviousPage: () => void;
  safeCurrentPage: number;
  totalPages: number;
  visiblePages: number[];
}

export const ProjectsPagination = ({
  canGoNext,
  onNextPage,
  onPageClick,
  onPreviousPage,
  safeCurrentPage,
  totalPages,
  visiblePages,
}: IProjectsPaginationProps) => {
  const hasPreviousPage = safeCurrentPage > 1;
  const hasNextPage = canGoNext ?? safeCurrentPage < totalPages;

  if (!hasPreviousPage && !hasNextPage) return null;

  return (
    <Pagination aria-label="Projects pagination">
      <PageButton
        aria-label="Previous page"
        disabled={!hasPreviousPage}
        htmlType="button"
        onClick={onPreviousPage}
        type="text"
      >
        <Icon icon="chevron_left" $size={18} />
      </PageButton>
      {visiblePages.map((page, index) =>
        page === PAGINATION_ELLIPSIS ? (
          <PaginationEllipsis key={`ellipsis-${index}`}>...</PaginationEllipsis>
        ) : (
          <PageButton
            $active={page === safeCurrentPage}
            aria-current={page === safeCurrentPage ? "page" : undefined}
            htmlType="button"
            key={page}
            onClick={() => onPageClick({ pageNumber: page })}
            type="text"
          >
            {page}
          </PageButton>
        ),
      )}
      <PageButton
        aria-label="Next page"
        disabled={!hasNextPage}
        htmlType="button"
        onClick={onNextPage}
        type="text"
      >
        <Icon icon="chevron_right" $size={18} />
      </PageButton>
    </Pagination>
  );
};
